import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useEffect, useRef } from 'react';
import { BREAKPOINTS } from '@presentation/styles';
import { useMediaQuery } from 'react-responsive';
import { Button } from '../Button';
import * as Styled from './styled';
import { WhatsappButton } from '../WhatsappButton';
import type { FixedButtonBannerProps } from './types';

const TOP_TO_SHOW_FIXED_BANNER = 700;

export const FixedButtonBanner: FC<FixedButtonBannerProps> = (props) => {
  const { from, onClick, type = 'application' } = props;
  const fixedBannerRef = useRef<HTMLDivElement>(null);
  const { translate } = useTranslation();
  const isTablet = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.medium}px)` });

  useEffect(() => {
    const handler = () => {
      if (!fixedBannerRef.current) {
        return;
      }

      const show = window.scrollY > TOP_TO_SHOW_FIXED_BANNER && isTablet;
      fixedBannerRef.current.style.display = show ? 'flex' : 'none';
    };

    document.addEventListener('scroll', handler);

    return () => document.removeEventListener('scroll', handler);
  }, [isTablet]);

  return (
    <Styled.FixedBanner ref={fixedBannerRef}>
      {type === 'application' ? (
        <Button key="apply" color="blue" onClick={onClick} shrink data-from={from}>
          {translate('common.buttons.apply')}
        </Button>
      ) : null}

      {type === 'whatsapp' ? (
        <WhatsappButton size="medium" outlined={false} onClick={onClick} shrink data-from={from} />
      ) : null}
    </Styled.FixedBanner>
  );
};
